import { SEO_PAGES } from '@/pages/seo/seoPageData';
import { addGoogleAdsKeywordParam, GOOGLE_ADS_KEYWORD_QUERY_PARAM } from '@/lib/googleAdsKeyword';

/**
 * Contesto SEO → brief:
 * le chiavi ammesse sono tutti gli slug delle landing SEO statiche.
 * In questo modo nuove pagine SEO ereditano automaticamente il contesto.
 */
export const BRIEF_SEO_CONTEXT_KEYS = Array.from(
  new Set(SEO_PAGES.map((p) => p.slug)),
);

/** Contesto generico da landing principale (/). */
export const BRIEF_MAIN_LANDING_CONTEXT_KEY = 'landing-main';
export const BRIEF_L_COM_B_LANDING_CONTEXT_KEY = 'landing-l-com-b';

/** Chiavi extra non SEO ma abilitate per avvio brief guidato. */
export const BRIEF_ADDITIONAL_CONTEXT_KEYS = [
  BRIEF_MAIN_LANDING_CONTEXT_KEY,
  BRIEF_L_COM_B_LANDING_CONTEXT_KEY,
] as const;

export type BriefSeoContextKey = string;

const BRIEF_CONTEXT_KEYS_SET = new Set([
  ...BRIEF_SEO_CONTEXT_KEYS,
  ...BRIEF_ADDITIONAL_CONTEXT_KEYS,
]);

export function isBriefSeoContextKey(v: string | null | undefined): v is BriefSeoContextKey {
  return !!v && BRIEF_CONTEXT_KEYS_SET.has(v);
}

/** Query param usato nell'URL /brief?bc=... */
export const BRIEF_SEO_CONTEXT_QUERY = 'bc';
export const BRIEF_GOOGLE_ADS_KEYWORD_QUERY = GOOGLE_ADS_KEYWORD_QUERY_PARAM;

/** Link a /brief con contesto SEO se lo slug della landing è tra quelli abilitati */
export function briefHrefWithOptionalSeoContext(pageSlug: string): string {
  const params = new URLSearchParams();
  if (isBriefSeoContextKey(pageSlug)) {
    params.set(BRIEF_SEO_CONTEXT_QUERY, pageSlug);
  }
  addGoogleAdsKeywordParam(params);
  return params.size > 0 ? `/brief?${params.toString()}` : '/brief';
}

export function addBriefSeoContextParam(params: URLSearchParams, pageSlug: string): void {
  if (isBriefSeoContextKey(pageSlug)) {
    params.set(BRIEF_SEO_CONTEXT_QUERY, pageSlug);
  }
  addGoogleAdsKeywordParam(params);
}

/** Link a /brief con contesto generico della landing principale. */
export function briefHrefWithMainLandingContext(): string {
  const params = new URLSearchParams();
  addBriefMainLandingContextParam(params);
  return `/brief?${params.toString()}`;
}

export function addBriefMainLandingContextParam(params: URLSearchParams): void {
  params.set(BRIEF_SEO_CONTEXT_QUERY, BRIEF_MAIN_LANDING_CONTEXT_KEY);
  addGoogleAdsKeywordParam(params);
}

export function addBriefGoogleAdsKeywordParam(params: URLSearchParams): void {
  addGoogleAdsKeywordParam(params);
}
